import React, { useContext, useMemo } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import MetaDropdown from "@components/MetaDropdown"
import LanguageContext from "@context/LanguageContext"

import { Link } from "gatsby"
import { useLocation } from "@reach/router"

export default ({ isInMenu, textColor }) => {
  const { t } = useTranslation()
  const context = useContext(LanguageContext)

  const dropdownClass = `${isInMenu ? "bg-transparent border-0" : "bg-white"}`
  const toggleClass = `${
    isInMenu
      ? `!border-0 block no-underline ${textColor} px-6 py-4 md:!px-0 md:mr-2 md:py-5 uppercase text-xs md:text-tiny fhd:text-base font-bold font-inter transition-colors hover:text-mgreen`
      : ""
  }`
  const menuItemClass = `${isInMenu ? textColor : ""}`

  let elements = [
    {
      lang: "en",
      title: "English",
      url: "/",
    },
    {
      lang: "de",
      title: "Deutsch",
      url: "/de",
    },
    {
      lang: "es",
      title: "Español",
      url: "/es",
    },
  ]
  const location = useLocation()

  let pathName = location.pathname

  const arrAvailableLanguages = context.availableLanguages

  if (arrAvailableLanguages.length > 3) {
    elements = arrAvailableLanguages.map(lang => {
      return {
        lang,
        title: t(lang + "_language"),
        url: `/${lang === "en" ? "" : lang}`,
      }
    })
  }

  const elementsUrl = elements
    .map(element => element.url)
    .filter(url => url !== "/")

  if (elementsUrl.some(url => pathName.startsWith(url))) {
    pathName = pathName.substring(4)
  } else {
    pathName = pathName.substring(1)
  }

  const newElements = useMemo(() => {
    return elements.map((record, index) => ({
      ...record,
      url: `${record.url}${index === 0 ? "" : "/"}${pathName}`,
    }))
  }, [pathName])

  const handleClick = lng => {
    let usedLng
    if (lng === "es") {
      usedLng = "es"
    } else if (lng === "de") {
      usedLng = "de"
    } else {
      usedLng = "en"
    }
    localStorage.setItem("lastChosenLanguage", usedLng)
  }

  return (
    <div>
      <MetaDropdown id={"lang_id"} className={dropdownClass}>
        <MetaDropdown.Toggle className={toggleClass + " !px-3"}>
          <span>
            {(context.language && context.language.toUpperCase()) || "EN"}
          </span>
        </MetaDropdown.Toggle>
        <MetaDropdown.Menu>
          {newElements.map(option => (
            <MetaDropdown.Item
              as={Link}
              key={option.title}
              eventKey={option.url}
              className={menuItemClass}
              to={option.url}
              onClick={() => handleClick(option.lang)}
            >
              {option.title}
            </MetaDropdown.Item>
          ))}
        </MetaDropdown.Menu>
      </MetaDropdown>
    </div>
  )
}
